var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-circle-button",class:_vm.classes},[_c('BnIcon',{staticClass:"icon-circle-button__icon",attrs:{"name":_vm.icon,"color":"#B1CEC4"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }